var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalityBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 20,
    viewBox: "0 0 200 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#D9D9D9",
    stroke: "#838383",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 1.5,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#D9D9D9",
    stroke: "#838383",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 1.5,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#D9D9D9",
    stroke: "#838383",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 181.5,
    y: 1.5,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#D9D9D9",
    stroke: "#838383",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H60.5",
    stroke: "#838383",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5C16.5 4.5 21 10 40 10M63.5 4.5C63.5 4.5 59 10 40 10M40 10C21 10 16.5 15.5 16.5 15.5M40 10C59 10 63.5 15.5 63.5 15.5M20 7.5V12M60 7.5V12",
    stroke: "#838383",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 10H121",
    stroke: "#838383",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 4.5C76.5 4.5 81.5 10 100.5 10M123.5 4.5C123.5 4.5 119.5 10 100.5 10M100.5 10C81.5 10 76.5 15.5 76.5 15.5M100.5 10C119.5 10 123.5 15.5 123.5 15.5M80.5 7.5V12M120.5 7.5V12",
    stroke: "#838383",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139 10H180.5",
    stroke: "#838383",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 4.5C136.5 4.5 141 10 160 10M183.5 4.5C183.5 4.5 179 10 160 10M160 10C141 10 136.5 15.5 136.5 15.5M160 10C179 10 183.5 15.5 183.5 15.5M140 7.5V12M180 7.5V12",
    stroke: "#838383",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalityBar);
export default __webpack_public_path__ + "static/media/personality_bar.5f5aa9b9ed98b6ec9fd3020c69679e97.svg";
export { ForwardRef as ReactComponent };